<div
  #dietFormModal
  class="modal fade"
  id="importObjectsSelectorModal"
  tabindex="-1"
  aria-labelledby="importRoutineSelectorModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel" *ngIf="user">
          Importando de {{ user.firstName }}
        </h1>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="accordion" id="accordion">
          <div class="accordion-item" *ngFor="let object of parentObjects">
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse' + object.id"
                [attr.aria-controls]="'collapse' + object.id"
                aria-expanded="false"
                (click)="selectGroup(object)"
              >
                <div>
                  {{ object.name }}
                  <span
                    class="ms-2 progress-pill"
                    *ngIf="object.status == 'IN_PROGRESS'"
                    >En Progreso 💪🏼</span
                  >
                </div>
              </button>
            </h2>
            <div
              [id]="'collapse' + object.id"
              class="accordion-collapse collapse"
              data-bs-parent="#accordion"
            >
              <div class="accordion-body">
                <!-- <div
                  class="d-flex flex-lg-row flex-column justify-content-between"
                >
                  <div class="d-flex flex-row col-9 col-lg-4">
                    <h6>Vigencia: &nbsp;</h6>
                    <span class="d-flex flex-row">
                      {{ object.createdAt }}
                    </span>
                    <span> &nbsp;-&nbsp; </span>
                    <span *ngIf="!object.finishAt.Valid" class="me-3"
                      >presente</span
                    ><span *ngIf="object.finishAt.Valid" class="me-3">{{
                      object.finishAt!.Time
                    }}</span>
                  </div>
                </div> -->
                <div class="d-flex flex-column" *ngIf="objectType == 'routine'">
                  <div
                    class="routineModel p-2 m-1 w-100 rounded-2 row"
                    *ngFor="let routineModel of object.routines"
                    style="cursor: pointer"
                    (click)="importRoutineModel(routineModel)"
                  >
                    <div
                      class="col-12 d-flex align-items-center justify-content-between"
                    >
                      <span>{{ routineModel.name }}</span>
                      <span *ngIf="routineModel.imported" class="imported"
                        >Importada ✅</span
                      >
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-column" *ngIf="objectType == 'diet'">
                  <div
                    class="routineModel p-2 m-1 w-100 rounded-2 row"
                    *ngFor="let meal of object.meals"
                    style="cursor: pointer"
                    (click)="importMeal(meal)"
                  >
                    <div
                      class="col-12 d-flex align-items-center justify-content-between"
                    >
                      <span>{{ meal.title }}</span>
                      <span *ngIf="meal.imported" class="imported"
                        >Importada ✅</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModal()"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
